<script setup lang="ts">
type Props = {
    label: string
}

defineProps<Props>()
</script>

<template>
    <b-tab-item :label="label">
        <slot />
    </b-tab-item>
</template>
